import { render, staticRenderFns } from "./AssignmentAuthor.vue?vue&type=template&id=1b30b0b4&scoped=true&"
import script from "./AssignmentAuthor.vue?vue&type=script&lang=js&"
export * from "./AssignmentAuthor.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAuthor.vue?vue&type=style&index=0&id=1b30b0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30b0b4",
  null
  
)

export default component.exports